type KycProfileLike = {
  email?: string | null;
  kyc_status?: "incomplete" | "pending_review" | "approved" | "rejected" | null;
  is_verified?: boolean | null;
  nin_verified?: boolean | null;
};

const ROLE_DASHBOARDS = {
  lawyer: "/lawyer-dashboard",
  agent: "/agent-dashboard",
  client: "/client-dashboard",
} as const;

export type AppUserRole = keyof typeof ROLE_DASHBOARDS;

const DISALLOWED_POST_AUTH_PATHS = new Set([
  "/login",
  "/signup",
  "/auth/callback",
  "/forgot-password",
  "/reset-password",
]);

export function hasKycBypass(email?: string | null) {
  return false;
}

export function hasApprovedKyc(profile?: KycProfileLike | null) {
  if (!profile) {
    return false;
  }

  return Boolean(
    profile.kyc_status === "approved" &&
    profile.is_verified &&
    profile.nin_verified,
  );
}

export function hasKycRestrictions(profile?: KycProfileLike | null) {
  return false;
}

export function isAppUserRole(role?: string | null): role is AppUserRole {
  return Boolean(role && role in ROLE_DASHBOARDS);
}

export function getDashboardRouteForRole(role?: string | null, fallback = "/client-onboarding?setup=role") {
  if (!isAppUserRole(role)) {
    return fallback;
  }

  return ROLE_DASHBOARDS[role];
}

export function normalizeAppRedirect(redirectTo?: string | null, fallback = "/") {
  const safeFallback = fallback.startsWith("/") ? fallback : "/";
  if (!redirectTo) {
    return safeFallback;
  }

  const candidate = redirectTo.trim();
  if (!candidate) {
    return safeFallback;
  }

  if (typeof window === "undefined") {
    return candidate.startsWith("/") ? candidate : safeFallback;
  }

  try {
    const normalizedUrl = new URL(candidate, window.location.origin);

    if (normalizedUrl.origin !== window.location.origin) {
      return safeFallback;
    }

    if (DISALLOWED_POST_AUTH_PATHS.has(normalizedUrl.pathname)) {
      return safeFallback;
    }

    const normalizedPath = `${normalizedUrl.pathname}${normalizedUrl.search}${normalizedUrl.hash}`;
    return normalizedPath.startsWith("/") ? normalizedPath : safeFallback;
  } catch {
    return safeFallback;
  }
}
